// Embroidery Modal Functions
const UPPERCASE_FONT_TYPES = new Set(['circle']);
const SECOND_LETTER_UPPERCASE_FONT_TYPES = new Set(['fancy']);
let embroideryRawInputValue = '';
let embroideryDisplayedValue = '';

function getSelectedFontType() {
  return document.querySelector('input[name="font-type"]:checked')?.value || '';
}

function selectedFontRequiresUppercase() {
  return UPPERCASE_FONT_TYPES.has(getSelectedFontType());
}

function selectedFontRequiresSecondLetterUppercase() {
  return SECOND_LETTER_UPPERCASE_FONT_TYPES.has(getSelectedFontType());
}

function updateTextInputFontClass() {
  const textInput = document.getElementById('embroidery-text-input');
  if (!textInput) return;

  const fontInputs = document.querySelectorAll('input[name="font-type"]');
  fontInputs.forEach((input) => textInput.classList.remove(input.value));

  if (!textInput.value.trim()) {
    return;
  }

  const selectedFont = getSelectedFontType();
  if (selectedFont) {
    textInput.classList.add(selectedFont);
  }
}

window.openEmbroideryModal = function() {
  document.getElementById('embroidery-modal').style.display = 'block';
  document.body.style.overflow = 'hidden';

  // Update preview positioning based on coordinates
  // const previewText = document.getElementById('embroidery-preview-text');
  // if (previewText) {
  //   // Get coordinates from data attributes or inline styles
  //   const yCoord = '17%';
  //   const xCoord = previewText.style.left || '50%';

  //   previewText.style.top = yCoord;
  //   previewText.style.left = xCoord;
  // }
}

window.closeEmbroideryModal = function() {
  document.getElementById('embroidery-modal').style.display = 'none';
  document.body.style.overflow = 'auto';
}

window.resetEmbroideryForm = function() {
  // Reset text input
  const textInput = document.getElementById('embroidery-text-input');
  if (textInput) {
    textInput.value = '';
    embroideryRawInputValue = '';
    embroideryDisplayedValue = '';
  }

  // Reset to first font option
  const firstFont = document.querySelector('input[name="font-type"]');
  if (firstFont) {
    firstFont.checked = true;
  }

  updateTextInputFontClass();

  // Reset to first size option
  const firstSize = document.querySelector('input[name="embroidery-size"]');
  if (firstSize) {
    firstSize.checked = true;
  }

  // Reset to first color option
  const firstColor = document.querySelector('input[name="text-color"]');
  if (firstColor) {
    firstColor.checked = true;
  }

  // Update preview and character count
  updatePreview();
  updateCharacterCount();
  updateAddButton();
}

function updatePreview() {
  const textInput = document.getElementById('embroidery-text-input');
  const fontType = document.querySelector('input[name="font-type"]:checked')?.value || 'ariel-block';
  const fontSize = document.querySelector('input[name="font-type"]:checked')?.dataset?.fontSize;
  const textColor = document.querySelector('input[name="text-color"]:checked')?.value || 'pink';
  const embroiderySize = document.querySelector('input[name="embroidery-size"]:checked')?.value || '1';
  const embroiderySizeMultiplier = document.querySelector('input[name="embroidery-size"]:checked')?.dataset?.multiplier || 1;
  const previewText = document.getElementById('embroidery-preview-text');

  if (previewText) {
    if(fontType == 'circle') {
      const textInputValue = textInput?.value;
      const firstLetter =  textInputValue.charAt(0);
      const middleLetter =  textInputValue.slice(1, textInputValue.length - 1);
      const lastLetter =  textInputValue.length > 1 ? textInputValue.charAt(textInputValue.length - 1) : '';
      previewText.innerHTML = `<span style="font-family: 'Circle Monogram First'">${firstLetter}</span>
      <span style="font-family: 'Circle Monogram Middle'">${middleLetter}</span>
      <span style="font-family: 'Circle Monogram Last'">${lastLetter}</span>`
    }
    else {
      previewText.textContent = textInput?.value || '';
    }

    previewText.className = `embroidery-preview-text ${fontType} ${embroiderySize}`;
    previewText.style.color = getColorValue(textColor);

    if (fontSize) {
      previewText.style.setProperty('--font-size-custom', fontSize + 'cqi');
    } else {
      previewText.style.removeProperty('--font-size-custom');
    }

    if (embroiderySizeMultiplier){
      previewText.style.setProperty('--font-size-scale-custom', embroiderySizeMultiplier);
    } else {
      previewText.style.removeProperty('--font-size-scale-custom');
    }

    // Font size is now handled by CSS container queries (cqi units)
    // Remove any inline font-size so CSS can control it
    previewText.style.fontSize = '';
  }

  // Update selected labels
  // const selectedFont = document.getElementById('selected-font');
  const selectedColor = document.getElementById('selected-color');
  const selectedSize = document.getElementById('selected-size');

  // if (selectedFont) {
  //   selectedFont.textContent = formatFontName(fontType);
  // }
  if (selectedColor) {
    selectedColor.textContent = textColor.charAt(0).toUpperCase() + textColor.slice(1);
  }
  if (selectedSize) {
    const selectedSizeInput = document.querySelector(`input[name="embroidery-size"]:checked`);
    const sizeLabel = selectedSizeInput?.closest('.size-option')?.querySelector('.size-option__button')?.textContent || '';
    selectedSize.textContent = sizeLabel;
  }
}

function getColorValue(color) {
  const colors = {
    pink: '#F2D8D8',
    light_blue: '#89AABC',
    green: '#384E3A',
    red: '#9D3530',
    white: '#D4C9B2',
    navy: '#1C2833'
  };
  return colors[color.replace('-', '_')] || '#F2D8D8';
}

function formatFontName(fontType) {
  const fontNames = {
    'ariel': 'Ariel Block',
    'fancy': 'Fancy Monogram',
    'circle': 'Circle Monogram',
    'chain-stitch': 'Chain Stitch'
  };
  return fontNames[fontType] || fontType;
}

function formatFontForProperties(fontType) {
  const fontMapping = {
    'ariel': 'arial',
    'fancy': 'fancy',
    'circle': 'circle',
    'chain': 'chain'
  };
  return fontMapping[fontType] || fontType.replace('-', '_');
}

function formatColorForProperties(colorType) {
  const colorMapping = {
    'pink': 'Pink',
    'light_blue': 'Light Blue',
    'light-blue': 'Light Blue',
    'green': 'Green',
    'red': 'Red',
    'white': 'White',
    'navy': 'Navy'
  };
  return colorMapping[colorType] || colorType.charAt(0).toUpperCase() + colorType.slice(1);
}

function updateCharacterCount() {
  const textInput = document.getElementById('embroidery-text-input');
  const countElement = document.getElementById('character-count');

  if (textInput && countElement) {
    const count = textInput.value.length;
    const maxLength = textInput.getAttribute('maxlength') || '10';
    countElement.textContent = `${count}/${maxLength}`;
  }
}

function updateAddButton() {
  const textInput = document.getElementById('embroidery-text-input');
  const addBtn = document.getElementById('embroidery-add-btn');

  if (textInput && addBtn) {
    addBtn.disabled = textInput.value.trim().length === 0;
  }
}

window.addEmbroideryToCart = function() {
  const textInput = document.getElementById('embroidery-text-input');
  const fontType = document.querySelector('input[name="font-type"]:checked')?.value || 'ariel-block';
  const textColor = document.querySelector('input[name="text-color"]:checked')?.value || 'pink';
  const embroiderySize = document.querySelector('input[name="embroidery-size"]:checked')?.value || '1';

  // Get embroidery details
  const embroideryText = textInput?.value.trim() || '';
  const font = formatFontForProperties(fontType);

  // Get the readable size label
  const selectedSizeInput = document.querySelector('input[name="embroidery-size"]:checked');
  const fontSize = selectedSizeInput?.closest('.size-option')?.querySelector('.size-option__button')?.textContent || embroiderySize + '"';

  const location = 'chest_upper_center';
  const color = formatColorForProperties(textColor);

  // Create embroidery data object
  const embroideryData = {
    text: embroideryText,
    font: font,
    size: embroiderySize,
    font_size: fontSize,
    location: location,
    color: color,
    shippingNote: getShippingNote()
  };

  // Add embroidery as line item property to main product
  addEmbroideryToMainProduct(embroideryData);

  // Close modal
  closeEmbroideryModal();

  // Update display to show selected embroidery options
  updateEmbroideryDisplay(embroideryData);

  // Toggle add to cart buttons
  toggleAddToCartButtons();

  // Update preview text in selected state
  const selectedPreview = document.getElementById('embroidery-preview-text-selected');
  if (selectedPreview) {
    if(fontType == 'circle' || fontType == 'circle_monogram') {
      const textInputValue = textInput?.value;
      const firstLetter =  textInputValue.charAt(0);
      const middleLetter =  textInputValue.slice(1, textInputValue.length - 1);
      const lastLetter =  textInputValue.charAt(textInputValue.length - 1);
      selectedPreview.innerHTML = `<span style="font-family: 'Circle Monogram First'">${firstLetter}</span>
      <span style="font-family: 'Circle Monogram Middle'">${middleLetter}</span>
      <span style="font-family: 'Circle Monogram Last'">${lastLetter}</span>`
    }
    else {
      selectedPreview.textContent = embroideryText;
    }
    selectedPreview.style.color = getColorValue(textColor);
    selectedPreview.style.fontFamily = getFontFamily(fontType);
  }
}

function getShippingNote() {
  // Get shipping note from block settings (set in embroidery.liquid)
  // Returns empty string if not configured
  return window.theme.embroideryConfig?.shippingNote || '';
}

function getFontFamily(fontType) {
  const fontFamilies = {
    'ariel': 'Ariel Block',
    'fancy': 'Fancy Monogram',
    'circle': 'Circle Monogram',
    'chain': 'Chain Stitch'
  };
  return fontFamilies[fontType] || 'Ariel Block, sans-serif';
}

function addEmbroideryToMainProduct(embroideryData) {
  // Find the embroidery properties input
  const embroideryEnabled = document.getElementById('embroidery-enabled');

  if (!embroideryEnabled) {
    console.error('Embroidery properties input not found');
    return;
  }
  let embroideryDataSize = embroideryData.size;
  if (embroideryData.size.includes('small')) {
    embroideryDataSize = 'S'
  } else if (embroideryData.size.includes('large')) {
    embroideryDataSize = 'L'
  } else if (embroideryData.size.includes('one-size')) {
    embroideryDataSize = 'os'
  }

  const monogramString = `Text: ${embroideryData.text} | Font: ${embroideryData.font}_${embroideryDataSize} | Color: ${embroideryData.color}`;
  embroideryEnabled.value = monogramString;
  // Add the name attribute so it gets submitted
  embroideryEnabled.setAttribute('name', embroideryEnabled.getAttribute('data-property-name'));
}

function updateEmbroideryDisplay(embroideryData) {
  const embroideryCta = document.querySelector('.embroidery-cta');
  document.querySelector('.embroidery-cta-title').style.display = 'none';
  if (!embroideryCta) return;

  // Get font class name for styling
  const fontClass = embroideryData.font.replace('_', '-');

  // Replace CTA with selected embroidery options display
  embroideryCta.innerHTML = `
    <div class="embroidery-selected">
      <!-- Top Component: Header with tickbox, title, price, edit and remove buttons -->
      <div class="embroidery-selected__header">
        <div class="embroidery-selected__header-left">
          <div class="embroidery-selected__checkbox">
            <input type="checkbox" checked disabled>
            <span class="checkmark">✓</span>
          </div>
          <span class="embroidery-selected__title">Embroidery for $16.00</span>
        </div>
        <div class="embroidery-selected__header-right">
          <span class="embroidery-selected__price hidden">+ $16.00</span>
          <button type="button" class="embroidery-selected__edit" onclick="openEmbroideryModal()">
            Edit
          </button>
          <button type="button" class="embroidery-selected__remove" onclick="removeEmbroidery()">
            Delete
          </button>
        </div>
      </div>

      <!-- Middle Component: Preview and details -->
      <div class="embroidery-selected__middle">
        <div class="embroidery-selected__preview">
          <div class="embroidery-preview-text ${fontClass}" id="embroidery-preview-text-selected">${embroideryData.text}</div>
        </div>
        <div class="embroidery-selected__details">
          <div class="embroidery-detail">Font Type: ${formatFontName(embroideryData.font.replace('_', '-'))}</div>
          <div class="embroidery-detail">Text: ${embroideryData.text}</div>
          <div class="embroidery-detail">Embroidery Size: ${embroideryData.font_size}</div>
          <div class="embroidery-detail">Text Color: ${embroideryData.color}</div>
        </div>
      </div>

      <!-- Bottom Component: Shipping note -->
      ${embroideryData.shippingNote ? `
      <div class="embroidery-selected__shipping">
        <div class="shipping-note">${embroideryData.shippingNote}</div>
      </div>
      ` : ''}
    </div>
  `;
}

window.removeEmbroidery = function() {
  // Clear embroidery properties
  const embroideryEnabled = document.getElementById('embroidery-enabled');

  if (embroideryEnabled) {
    embroideryEnabled.value = '';
    // Remove the name attribute so it doesn't get submitted
    embroideryEnabled.removeAttribute('name');
  }

  document.querySelector('.embroidery-cta-title').style.display = 'block';

  // Reset to original CTA button
  const embroideryCta = document.querySelector('.embroidery-cta');
  const ctaLabel = window.theme.embroideryConfig?.ctaLabel || 'ADD EMBROIDERY';
  const embroideryPrice = window.theme.embroideryConfig?.price || '$0.00';
  if (embroideryCta) {
    embroideryCta.innerHTML = `
      <button type="button" class="embroidery-button" onclick="openEmbroideryModal()">
        <span class="embroidery-button__text">${ctaLabel} for ${embroideryPrice}</span>
        <span class="embroidery-button__action embroidery-button__add">Add</span>
      </button>
    `;
  }

  // Toggle add to cart buttons
  toggleAddToCartButtons();
}

// Event listeners
function toggleAddToCartButtons() {
  const embroideryEnabled = document.getElementById('embroidery-enabled');
  const hasEmbroidery = embroideryEnabled && embroideryEnabled.value && embroideryEnabled.value.trim() !== '';
  const normalButton = document.querySelector('[data-add-to-cart]:not(.atc-embroidery-button)');
  const embroideryButton = document.querySelector('.atc-embroidery-button');

  if (normalButton && embroideryButton) {
    if (hasEmbroidery) {
      // Hide normal button, show embroidery button
      normalButton.style.display = 'none';
      embroideryButton.style.display = 'block';
    } else {
      // Show normal button, hide embroidery button
      normalButton.style.display = 'block';
      embroideryButton.style.display = 'none';
    }
  }
}

// Function to handle embroidery button click
function handleEmbroideryButtonClick(event) {
  event.preventDefault();

  const button = event.currentTarget;
  const form = button.closest('form');

  if (!form) {
    console.error('Form not found for embroidery button');
    return;
  }

  // Validate form
  if (!form.checkValidity()) {
    form.reportValidity();
    return;
  }

  // Get embroidery product variant ID
  const embroideryButton = document.querySelector('.embroidery-cta-title');
  if (!embroideryButton) {
    console.error('Embroidery button not found');
    return;
  }

  const embroideryVariantId = embroideryButton.getAttribute('data-embroidery-variant-id');
  if (!embroideryVariantId) {
    console.error('Embroidery variant ID not found');
    return;
  }

  // Get main product variant ID
  const formData = new FormData(form);
  const mainProductVariantId = formData.get('id');
  if (!mainProductVariantId) {
    console.error('Main product variant ID not found');
    return;
  }

  // Show loading state
  button.classList.add('is-loading');
  button.disabled = true;

  // Note: The main product form already has the Monogram property that will be submitted
  // Just trigger the normal submit button - the syncEmbroideryQuantities function will
  // handle adding/updating the embroidery item automatically based on products with Monogram

  const normalSubmitButton = form.querySelector('[data-add-to-cart]:not(.atc-embroidery-button)');
  if (normalSubmitButton) {
    // Remove loading state from embroidery button
    button.classList.remove('is-loading');
    button.disabled = false;

    // Trigger the normal submit button click
    normalSubmitButton.click();
  } else {
    console.error('Normal submit button not found');
    button.classList.remove('is-loading');
    button.disabled = false;
  }
}
// Event listeners
document.addEventListener('DOMContentLoaded', function() {
  const textInput = document.getElementById('embroidery-text-input');
  const fontInputs = document.querySelectorAll('input[name="font-type"]');
  const colorInputs = document.querySelectorAll('input[name="text-color"]');
  const sizeInputs = document.querySelectorAll('input[name="embroidery-size"]');

  const ensureSelection = (input, start, end) => {
    if (typeof start === 'number' && typeof end === 'number' && input === document.activeElement) {
      input.setSelectionRange(start, end);
    }
  };

  const applyUppercaseForSelectedFont = () => {
    if (!textInput) return;

    updateTextInputFontClass();

    if (selectedFontRequiresUppercase()) {
      const start = textInput.selectionStart;
      const end = textInput.selectionEnd;
      const uppercased = textInput.value.toUpperCase();
      if (uppercased !== textInput.value) {
        textInput.value = uppercased;
      }
      embroideryDisplayedValue = textInput.value;
      ensureSelection(textInput, start, end);
    } else if (selectedFontRequiresSecondLetterUppercase()) {
      const chars = textInput.value.split('')
      if (chars[0]) chars[0] = chars[0].toLowerCase();
      if (chars[1]) chars[1] = chars[1].toUpperCase();
      if (chars[2]) chars[2] = chars[2].toLowerCase();

      textInput.value = chars.join('');
    } else {
      textInput.value = embroideryRawInputValue;
      embroideryDisplayedValue = textInput.value;
    }

    toggleAddToCartButtons();
    updateCharacterCount();
    updateAddButton();
  };

  const diffStrings = (previous, current) => {
    if (previous === current) {
      return { start: current.length, removedLength: 0, addedText: '' };
    }

    let start = 0;
    while (start < previous.length && start < current.length && previous[start] === current[start]) {
      start++;
    }

    let prevEnd = previous.length - 1;
    let currEnd = current.length - 1;
    while (prevEnd >= start && currEnd >= start && previous[prevEnd] === current[currEnd]) {
      prevEnd--;
      currEnd--;
    }

    const removedLength = prevEnd >= start ? prevEnd - start + 1 : 0;
    const addedText = currEnd >= start ? current.slice(start, currEnd + 1) : '';

    return { start, removedLength, addedText };
  };

  if (textInput) {
    embroideryRawInputValue = textInput.value;
    embroideryDisplayedValue = textInput.value;

    textInput.addEventListener('input', function() {
      const currentValue = textInput.value;
      const { start, removedLength, addedText } = diffStrings(embroideryDisplayedValue, currentValue);

      embroideryRawInputValue = embroideryRawInputValue.slice(0, start) +
        addedText +
        embroideryRawInputValue.slice(start + removedLength);

      embroideryDisplayedValue = currentValue;

      if (selectedFontRequiresUppercase()) {
        const startPos = textInput.selectionStart;
        const endPos = textInput.selectionEnd;
        const uppercasedCurrent = currentValue.toUpperCase();
        if (uppercasedCurrent !== currentValue) {
          textInput.value = uppercasedCurrent;
          embroideryDisplayedValue = uppercasedCurrent;
          ensureSelection(textInput, startPos, endPos);
        }
      } else if (selectedFontRequiresSecondLetterUppercase()) {
        const chars = textInput.value.split('')
        if (chars[0]) chars[0] = chars[0].toLowerCase();
        if (chars[1]) chars[1] = chars[1].toUpperCase();
        if (chars[2]) chars[2] = chars[2].toLowerCase();

        textInput.value = chars.join('');
      } else {
        embroideryRawInputValue = textInput.value;
      }

      updatePreview();
      updateCharacterCount();
      updateAddButton();
      toggleAddToCartButtons(); // Toggle buttons when text changes
      updateTextInputFontClass();
    });

    applyUppercaseForSelectedFont();
  }

  fontInputs.forEach(input => {
    input.addEventListener('change', function() {
      applyUppercaseForSelectedFont();
      updatePreview();
    });
  });

  colorInputs.forEach(input => {
    input.addEventListener('change', updatePreview);
  });

  sizeInputs.forEach(input => {
    input.addEventListener('change', updatePreview);
  });

  // Initialize preview on load
  updatePreview();
  updateCharacterCount();
  updateAddButton();

  // Initialize button toggle
  toggleAddToCartButtons();

  // Add event listener to embroidery button
  const embroideryButton = document.querySelector('.atc-embroidery-button');
  if (embroideryButton) {
    embroideryButton.addEventListener('click', handleEmbroideryButtonClick);
  }
});
